export default function QuarterCircleMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1791)">
                <rect width="100%" height="100%" transform="matrix(1 0 0 -1 0 1000)" fill="white" />
                <path d="M1000 1000H996.32C997.547 1000 998.774 999.987 1000 999.973V1000Z" fill="#01B4EE" />
                <path d="M347.146 0H1000V649.133C998.773 649.133 997.547 649.16 996.307 649.16C637.787 649.16 347.146 358.52 347.146 0Z" fill="#01B4EE" />
                <path d="M996.293 1000H0V86.3333C43.7733 598.2 473.106 1000 996.293 1000Z" fill="#01B4EE" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1791">
                    <rect width="100%" height="100%" fill="white" transform="matrix(1 0 0 -1 0 1000)" />
                </clipPath>
            </defs>
        </svg>

    )
}